"use client";

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { createContext, use, useCallback, useMemo, useState } from "react";

interface VisualizationGuardTourSignalValue {
	isVisualizationGuardActive: boolean;
	setVisualizationGuardActive: (active: boolean) => void;
}

const VisualizationGuardTourSignalContext =
	createContext<VisualizationGuardTourSignalValue | null>(null);

export function VisualizationGuardTourSignalProvider({
	children,
}: {
	children: React.ReactNode;
}) {
	const [isVisualizationGuardActive, setActive] = useState(false);

	const setVisualizationGuardActive = useCallback((active: boolean) => {
		setActive(active);
	}, []);

	const value = useMemo(
		() => ({
			isVisualizationGuardActive,
			setVisualizationGuardActive,
		}),
		[isVisualizationGuardActive, setVisualizationGuardActive],
	);

	return (
		<VisualizationGuardTourSignalContext value={value}>
			{children}
		</VisualizationGuardTourSignalContext>
	);
}

export function useVisualizationGuardTourSignal(): VisualizationGuardTourSignalValue {
	const context = use(VisualizationGuardTourSignalContext);
	if (!context) {
		throw new Error(
			"useVisualizationGuardTourSignal must be used within VisualizationGuardTourSignalProvider",
		);
	}
	return context;
}
